import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";

const UpdateKyndModal = (props) => {
	
	const handleClose = () => {
		
	};
	
	return (
		<Dialog
			open={props.open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Updating...
			</DialogTitle>
			<DialogContent>
				<Box sx={{ textAlign: "center", marginTop: "3em", marginBottom: "1em" }}>
					<CircularProgress sx={{ margin: "auto", textAlign: "center" }} />
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default UpdateKyndModal;